import React from 'react';
import styled from 'styled-components';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import {Row, ContainerCol} from '../componentes_generales/componentes_formulario/contenedores';
import { LabelForm, LabelNota } from '../componentes_generales/componentes_formulario/labels';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actualizarEstImpresionDcto } from '../../actions/ventas/act_ven02';

const ContenedorModal = styled.div`
  margin-top: 20px;
  height: 250px;
  width: 310px;
`;

class DocumentosGeneradosPorImprimir extends React.Component{
    
    constructor(props) {
        super(props);
        this.state = {
            colsDefDocPorImprimir: [
                {   header: "No.",
                    field: "Nro",
                    width: 33,
                    type: "string"
                },
                {   header: "Doc. Generado",
                    field: "NroDocumento",
                    width: 125,
                    type: "string"
                },
                {   header: "Estado",
                    field: "EstadoImp",
                    width: 150,
                    type: "string"
                }
            ],            
            
            bloquearCierreModal: true
        }

        this.gridDetDocsPorImpOptions = {
            enableColResize: true,

            onCellDoubleClicked: ((event)=>{
                
                let nroDocumento = event.data.NroDocumento;
                let parametrosImpReporte = '';

                switch(this.props.tipoComprob){
                    case 'PROF': // PROFORMAS
                        parametrosImpReporte += '&rpt=2&param1=' + nroDocumento;
                        break;
                    case 'DEV': // DEVOLUCIONES
                        parametrosImpReporte += '&rpt=4&param1=' + nroDocumento;
                        break;
                    case 'ETIQ': // ETIQUETAS DE DESPACHO DE CAJA
                        parametrosImpReporte += `&rpt=76&param1=${nroDocumento.substr(0, 6)}`;
                        parametrosImpReporte += `&param2=${nroDocumento.substr(7, 2)}/${this.props.docsPorImprimir.length}`;
                        if(this.props.parametroAdic.length>0){
                            parametrosImpReporte += `&param3=${this.props.parametroAdic}`;
                        }
                        console.log(parametrosImpReporte)
                        break;
                    default:
                        alert('No se ha especificado el tipo de reporte que desea imprimir.');
                        return;
                }
                    
                visualizarReporteEnPdf(parametrosImpReporte);

                this.props.actualizarEstImpresionDcto({...event.data, EstadoImp: 'IMPRESO'});
                if(this.validarCierreModalComprobAImp()===true){
                    this.setState({ bloquearCierreModal: false });
                }
            })
        }        

        this.onGridDetDocsPorImpReady = this.onGridDetDocsPorImpReady.bind(this);        
        this.validarCierreModalComprobAImp = this.validarCierreModalComprobAImp.bind(this);
    }

    onGridDetDocsPorImpReady(params){
        this.gridDetComPorImpApi = params.api;
        this.gridDetCompPorImpColumnApi = params.columnApi;
    }
 
    validarCierreModalComprobAImp(){
        if (this.props.docsPorImprimir === null && this.props.docsPorImprimir === undefined){
            return false;
        }
        let contComprobImp = 0;
        this.props.docsPorImprimir.forEach(comprob => {
            if (comprob.EstadoImp.toString().toUpperCase() === 'IMPRESO'){
                contComprobImp+=1;
            }
        });
        if(contComprobImp<this.props.docsPorImprimir.length){
            return false;
        }
        return true;
    }

    render(){
        return(
            <ModalResponsive
                open={this.props.isVisibleCompGenPorImp}
                onClose={this.props.onClose}
                ocultarClose={true}>
                <ContenedorModal>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <LabelForm>{this.props.tituloDocPorImp}</LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <AgGridRender altura='150px' data={this.props.docsPorImprimir} columnas={this.state.colsDefDocPorImprimir}
                                gridOptions={this.gridDetDocsPorImpOptions} onGridReady={this.onGridDetDocsPorImpReady}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-8'>
                            <LabelNota>Doble clic sobre la fila del documento a imprimir.</LabelNota>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-danger btn-sm'
                                    disabled={this.state.bloquearCierreModal}
                                    onClick={()=>{this.props.onClose(); this.setState({bloquearCierreModal: true});}}>
                                    <i className='fa fa-times-circle fa-lg'></i> Salir
                                </button>
                            </div>
                        </ContainerCol>
                    </Row>                    
                </ContenedorModal>
            </ModalResponsive>
        );
    }
}

const mapStateToProps = ((state) => {
    return {
        docsPorImprimir: state.ventas.docsPorImprimir
    };
});
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ actualizarEstImpresionDcto }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(DocumentosGeneradosPorImprimir);